import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  Input,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { IconoirInfoCircle, IconoirNavArrowRight } from '@ey-xd/motif-icon';
import { MotifIconModule, MotifTooltipModule } from '@ey-xd/ng-motif';
import { CoaSummary, CoaSummaryProcessed } from 'app/models/coa-summary';

@Component({
  selector: 'app-chart-account-summary',
  standalone: true,
  imports: [CommonModule, MotifIconModule, MotifTooltipModule],
  templateUrl: './chart-account-summary.component.html',
  styleUrl: './chart-account-summary.component.scss',
})
export class ChartAccountSummaryComponent implements AfterViewInit {
  private _coaSummary?: CoaSummary;
  private _coaSummaryProcessed?: CoaSummaryProcessed;

  hoverableInfo: string = `Some records may be unmapped due to one or more of the following reasons:
    • Missing account code in Trial Balance.
    • Account code not present in the latest CoA and missing account description for Level 2 and above in Trial Balance.
    • AI prediction failure.`;

  @ViewChild('tooltipTemplate') tooltipTemplate!: TemplateRef<any>;
  tooltipTemplateRef!: TemplateRef<any>;

  @Input()
  set coaSummary(value: CoaSummary) {
    this._coaSummary = value;
    this._coaSummaryProcessed = CoaSummaryProcessed.processCoaSummary(value);
  }

  get coaSummary(): CoaSummary | undefined {
    return this._coaSummary;
  }

  @Input()
  set coaSummaryProcessed(value: CoaSummaryProcessed) {
    this._coaSummary = undefined;
    this._coaSummaryProcessed = value;
  }

  get coaSummaryProcessed(): CoaSummaryProcessed | undefined {
    return this._coaSummaryProcessed;
  }

  IconoirInfoCircle = IconoirInfoCircle;
  IconoirNavArrowRight = IconoirNavArrowRight;

  constructor() {}

  ngAfterViewInit(): void {
    // Assign the template after view has initialized
    this.tooltipTemplateRef = this.tooltipTemplate;
  }

  showTooltipOnEnter(event: KeyboardEvent | Event) {
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      activeElement.click();
    }
  }

  // to format bullet points
  formatTooltipContent(value: string): string {
    if (!value) {
      return value;
    }

    const bullets = ['•'];
    let formattedValue = value.replace(/\n/g, ' \n');

    bullets.forEach((bullet: string) => {
      const regex = new RegExp(`\\s*${bullet}`, 'g');
      formattedValue = formattedValue.replace(regex, `\n${bullet}`);
    });

    return formattedValue.trim();
  }
}
